import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from './analytics';


export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location.pathname, location.search]);

  return null;
}